import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TypeReport } from '../models/reports/enums/TypeReport';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  refreshDetails = new BehaviorSubject<boolean>(false);
 
  typeReport =TypeReport;

  constructor(private http: HttpClient) { }

  getAll(): any {
    return this.http.get(`${environment.apiReports}/Reports/GetAllReports`);
  }

  ASNReport(params: any = null) {
    const apiUrl = `${environment.apiReports}/Reports/ASNReport`;
    if(!params){
      return this.http.get(apiUrl);
    }else{
      const options = {
        params: new HttpParams({ fromObject: params }),
        responseType: params.IsFile ? 'blob' as 'json' : 'json' as const,
      };
      return this.http.get(apiUrl, options);
    }
  } 

  getDNsforReport() {
    return this.http.get(`${environment.apiReports}/Reports/GetDNsforReport`);
   }

  dispatchNoteDetailsReport(params: any = null) {
    const apiUrl =`${environment.apiReports}/Reports/DispatchNoteDetailsReport`;
    const options = {
      params: new HttpParams({ fromObject: params }),
      responseType: params.IsFile ? 'blob' as 'json' : 'json' as const,
    };
    return this.http.get(apiUrl, options);
  }

  getOrganizationDetails() {
    return this.http.get(`${environment.apiReports}/Reports/GetOrganizationDetails`);
  }

  exportToExcel(ASNId: number) {
    return this.http.get(`${environment.apiReports}/Reports/ExportToExcel?ASNId=${ASNId}`, { responseType: 'blob' });
  }

  warehouseProductivityDefinition() {
    return this.http.get(`${environment.apiReports}/Reports/WarehouseProductivityDefinition`);
  }

  getWarehouseProductivity(data: any) {
    return this.http.post(`${environment.apiReports}/Reports/GetWarehouseProductivity`, data);
  }

  chemicalVolumeDefinition() {
    return this.http.get(`${environment.apiReports}/Reports/ChemicalVolumeDefinition`);
  }

  getChemicalVolume(data: any) {
    return this.http.post(`${environment.apiReports}/Reports/GetChemicalVolume`, data);
  }

  nearExpiryReportDefinition(id:number) {
    return this.http.get(`${environment.apiReports}/Reports/NearExpiryReportDefinition?ReportId=${id}`);
  }

  getDateOption() {
    return this.http.get(`${environment.apiReports}/Reports/GetDateOption`);
  }

  getNearExpiryReport(params: any) {
    const apiUrl = `${environment.apiReports}/Reports/GetNearExpiryReport`;
    const options = {
      params: new HttpParams({ fromObject: params }),
      responseType: params.IsFile ? 'blob' as 'json' : 'json' as const,
    };
    return this.http.post(apiUrl, options);
  }

  getGatePassReport(params: any) {
    return this.http.post(`${environment.apiReports}/Reports/GetGatePassReport`, null, { params });
  }

  GetStockLocationWise(params: any = null) {
    const apiUrl = `${environment.apiReports}/Reports/GetStockLocationWise`;
    const options = {
      params: new HttpParams({ fromObject: params }),
      responseType: params.IsFile ? 'blob' as 'json' : 'json' as const,
    };
    return this.http.get(apiUrl, options);
  }

  expectedReceivingReport(params: any = null) {
   const apiUrl =`${environment.apiReports}/Reports/ExpectedReceivingReport`;
    const options = {
      params: new HttpParams({ fromObject: params }),
      responseType: params.IsFile ? 'blob' as 'json' : 'json' as const,
    };
    return this.http.get(apiUrl, options);
    
  }

  addMyReportInfo(data: any) {
    return this.http.post(`${environment.apiReports}/Reports/AddMyReportInfo`, data);
  }

  orderSummaryPlanning(params: any = null) {
    const apiUrl =`${environment.apiReports}/Reports/OrderSummaryPlanning`;
     const options = {
       params: new HttpParams({ fromObject: params }),
       responseType: params.IsFile ? 'blob' as 'json' : 'json' as const,
     };
     return this.http.get(apiUrl, options);
     
   }

  stockWise(params: any,type:string ) {
    let apiUrl:string = '';
   
    if(type === this.typeReport.Stock_LPN_Wise)
     apiUrl = `${environment.apiReports}/Reports/StockLPNWise`;

    if(type === this.typeReport.Stock_SKU_Wise)
      apiUrl = `${environment.apiReports}/Reports/StockSKUWise`;

    if(type === this.typeReport.Stock_Zone_Wise)
      apiUrl = `${environment.apiReports}/Reports/StockZoneWise`;

    if(type === this.typeReport.Empty_Location)
      apiUrl = `${environment.apiReports}/Reports/EmptyLocation`;

    const options = {
      params: new HttpParams({ fromObject: params }),
      responseType: params.IsFile ? 'blob' as 'json' : 'json' as const,
    };
    return this.http.get(apiUrl, options);
   
  }

  inboundSummaryDateRange(params: any) {
    const apiUrl = `${environment.apiReports}/Reports/InboundSummaryDateRange`;
    const options = {
      params: new HttpParams({ fromObject: params }),
      responseType: params.IsFile ? 'blob' as 'json' : 'json' as const,
    };
    return this.http.get(apiUrl, options);
  }

  outboundSummaryDateRange(params: any) {
    const apiUrl = `${environment.apiReports}/Reports/OutboundSummaryDateRange`;
    const options = {
      params: new HttpParams({ fromObject: params }),
      responseType: params.IsFile ? 'blob' as 'json' : 'json' as const,
    };
    return this.http.get(apiUrl, options);
  }
  
  getLPNCountInDateRange(data: any) {
    return this.http.get(`${environment.apiReports}/Reports/GetLPNCountInDateRange?From_Date=${data.From_Date}&To_Date=${data.To_Date}&OrganizationID=${data.OrganizationID}`, { responseType: 'blob' });
  }

}
